import { Button } from "../ui/button";
import { Icons } from "@/components/Icons";
import { MarketingLink } from "@/components/OptionalLink";

export const Cta = () => {
  return (
    <section id="cta" className="bg-muted/50 py-16">
      <div className="container lg:grid lg:grid-cols-2 place-items-center">
        <div className="lg:col-start-1">
          <h2 className="text-3xl md:text-4xl font-bold ">
            Your app ready to
            <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">
              {" "}
              go live{" "}
            </span>
          </h2>
          <p className="text-muted-foreground text-xl mt-4 mb-8 lg:mb-0">
            You built it with AI. Don&apos;t let deployment be the thing that stops you. Push
            to GitHub - your app is live on your server. Don&apos;t waste time configuring
            Linux server, learning Docker or how to get your app running in Cloudflare.
          </p>
        </div>

        <div className="w-full flex justify-end items-center flex-col md:flex-row gap-4">
          <Button className="w-full md:w-auto" asChild>
            <MarketingLink href="/dashboard" className="flex gap-2 items-center">
              Get Started
            </MarketingLink>
          </Button>

          <Button className="w-full md:w-auto" asChild>
            <MarketingLink
              href="https://discord.gg/BHbfmaAGb7"
              className="flex gap-2 items-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icons.discord className="w-4 h-4" />
              Reach out to us
            </MarketingLink>
          </Button>
        </div>
      </div>
    </section>
  );
};
